import React from "react";
import styles from "./styles.module.css";
import { DialogProps } from "../types";
import { Spacing } from "spacing/component";
import { Button } from "components/buttons/Button";
import { TextBody1 } from "fonts/Body1";

export const OKDialog = ({ text, onClick }: DialogProps) => (
  <div className={styles.component}>
    <Spacing ph="xs" pb="s" pt="2xl">
      <TextBody1 centered>{text}</TextBody1>
      <Spacing pt="2xl" />
      <Button className={styles.button} text="OK" {...{ onClick }} />
    </Spacing>
  </div>
);
